export default function renderDangerousHtml(content: any) {
  return { __html: content }
}
